RivalIQ.apps.Reports.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const widgetTypes = RivalIQ.enums.widgetTypes;

    const widgets = [
        {
            instanceId: 'reports',
            widgetId: widgetTypes.SCHEDULED_REPORTS
        }
    ];

    const Dashboard = RivalIQ.apps.Dashboard;
    curations.Scheduled = Dashboard.models.Curation.extend({
        prependBeforeFilters: [
            curations.filters.loadScheduledReports
        ].concat(Dashboard.models.Curation.prototype.prependBeforeFilters),
        beforeFilters: [
            curations.filters.noScheduledReports
        ],
        title: 'Scheduled Exports',
        widgetDefinitions: widgets,
        companySets: false,
        timePeriod: false,
        export: false
    });
});
